import { MONTHS, WEEKDAYS } from "./constants";
import { TimeBrokerTable } from "./TimeBrokerTable";
import { DaySelector } from "./DaySelector";
import { Utils } from "./Utils";

export class BrokerSystem {
  constructor() {
    // Try to load saved date from localStorage, fallback to current date
    const savedDate = localStorage.getItem("selectedDate");
    this.selectedDate = savedDate ? new Date(savedDate) : new Date();

    // Initialize currentDate based on selectedDate instead of new Date()
    this.currentDate = new Date(this.selectedDate);

    this.timeTable = new TimeBrokerTable();
    this.daySelector = new DaySelector(this.handleDateSelect.bind(this));

    this.setupEventListeners();
    this.updateMonthDisplay();
    this.daySelector.initialize(this.currentDate, this.selectedDate);
    this.adjustTableHeight();

    // Initial load of bookings
    this.timeTable.updateDate(this.selectedDate);
	
	this.setCurDate(this.selectedDate);
	
    window.addEventListener("load", () => this.adjustTableHeight());
    window.addEventListener("resize", () => this.adjustTableHeight());
  }

  handleDateSelect(date) {
    this.selectedDate = date;
    // Save selected date to localStorage
    localStorage.setItem("selectedDate", date.toISOString());

    this.timeTable.updateDate(date);

    document.querySelectorAll(".day-button").forEach((button) => {
      button.classList.remove("selected");
    });

    const buttons = Array.from(document.querySelectorAll(".day-button"));
    const selectedIndex = date.getDate() - 1;
    if (buttons[selectedIndex]) {
      buttons[selectedIndex].classList.add("selected");
    }
	
	this.setCurDate(date);
  }
  
  setCurDate(date) {
	document.getElementById("curDay").textContent = WEEKDAYS[this.daySelector.getWeekDay(date)];
	document.getElementById("curDate").textContent = date.getDate() + '.' + (date.getMonth() + 1);
  }

  adjustTableHeight() {
    const tableContainer = document.querySelector(".overflow-x-auto");
    const windowHeight = window.innerHeight;

    // Set table container height to window height
    tableContainer.style.height = `${windowHeight}px`;
  }

  updateMonthDisplay() {
    const monthYear = document.getElementById("currentMonth");
    monthYear.textContent = `${
      MONTHS[this.currentDate.getMonth()]
    } ${this.currentDate.getFullYear()}`;
  }

  setupEventListeners() {
    document.getElementById("prevMonth").addEventListener("click", () => {
      this.currentDate.setMonth(this.currentDate.getMonth() - 1);
      this.updateMonthDisplay();
      this.daySelector.initialize(this.currentDate, this.selectedDate);
    });

    document.getElementById("nextMonth").addEventListener("click", () => {
      this.currentDate.setMonth(this.currentDate.getMonth() + 1);
      this.updateMonthDisplay();
      this.daySelector.initialize(this.currentDate, this.selectedDate);
    });

    document.getElementById("timeTable").addEventListener("click", (e) => {
      const cell = e.target.closest("td[data-hour]");
      if (cell) {
        const hour = cell.dataset.hour;
        const room = cell.dataset.room;
        console.log(
          `Clicked: Hour ${hour}, Room ${room}, Date: ${this.selectedDate.toLocaleDateString(
            "ru-RU"
          )}`
        );
      }
    });
  }
}
